<template>
    <div :class="cssLoading">
        <ProgressSpinner />
    </div>
</template>

<script>
    import ProgressSpinner from 'primevue/progressspinner';
    import store from "@/store";

    export default {
        name: "LoadingPage",
        components: { ProgressSpinner },

        data(){
            return {
                cssLoading: 'p-col-12 loading loading-'+ store.getStaticMenu()
            }
        }
    }
</script>

<style scoped>

    .loading {
        position: fixed;
        z-index: 999;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .loading-static {
        height: 8em;
        width: 8em;
        left: 250px;
    }

    .loading-overlay {
        height: 2em;
        width: 10em;
    }

    @media (max-width: 1024px) {
        .loading, .loading-overlay, .loading-static {
            height: 8em;
            width: 8em;
            left: 0;
        }
    }

</style>
